import { UsersSyncErrorsTab } from "./UsersSyncErrorsTab";

export default UsersSyncErrorsTab;
